/**
 * Coin symbols that trigger the EU/EEA restriction modal when paired with EUR.
 * Comparisons are done case-insensitively.
 */
export const EU_RESTRICTED_COINS = ['USDT', 'USDT0'];
